import { setLoginState, setLoginUser } from '../views/backend/Auth/state/auth-slice';
import { useHistory } from 'react-router-dom'

export const useLogoutUser = (dispatch) => {
    
    dispatch(setLoginUser(false));
    dispatch(setLoginState(null));
    const history = useHistory();
    history.push("/auth/sign-in")

}

export const formatCurrency = (value, decimals = 0) => {
  if (value === null || value === undefined || value === '') return '';
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  
  const formatted = new Intl.NumberFormat('it-IT', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(num);
  
  return `€ ${formatted}`;
}